import React from 'react';
import PageTemplate from '../components/PageTemplate';

/**
 * Page Politique de confidentialité
 */
const Privacy = () => {
  return <PageTemplate slug="privacy" />;
};

export default Privacy;
